import React from "react";

const ExcellenceSection = () => {
  const awards = [
    {
      title: "About image",
      img: "https://www.cbnme.com/real-estate-leaders-awards-2024/images/2024/slider/21.webp",
    },
    {
      title: "About image",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoI3H5CyG-3vjwySFlI9iBsM3R_PeUqHj5NWlNVRxUphEb5XKhdCTfwfRzeRbhso0JAVw&usqp=CAU",
    },
    {
      title: "About image",
      img: "https://www.cbnme.com/the-kingdom-realty-awards-2025/images/gallery-2025/38.jpg",
    },
    {
      title: "About image",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRMuyJBYUDQvPAOy6saKAG6bat85va6eh1jqVZrb3OvWROGkEkrLHQffkQcqcEgkeSEA5I&usqp=CAU",
    },
    {
      title: "About image",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxLMgSeKU0BogugTug4PwOHdk6VvmWK-zZCYFSiJa1PpSgwsW6wsk7jPJnRvZTgnnLhyo&usqp=CAU",
    },
  ];

  return (
    <section className="excellence-container">
      <header className="excellence-header">
        <h1 className="main-title">Frames of Excellence</h1>
        <p className="sub-title">Where vision meets reality at Inframantra</p>
      </header>

      <div className="awards-content">
        {/* <h3 className="section-label">Awards Section</h3> */}
        <div className="awards-grid">
          {awards.map((award) => (
            <div key={award.id} className="award-card">
              <div className="image-wrapper">
                <img src={award.img} alt={award.title} />
              </div>
              <p className="award-caption">
                {" "}
                {award.id} {award.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExcellenceSection;
